import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { Cfg } from '@hmax-order/shared/types';
import { CfgService } from '../service/cfg.service';

@Injectable({
  providedIn: 'root',
})
export class CfgResolver implements Resolve<Cfg[]> {
  private _cfgService = inject(CfgService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Cfg[]> {
    return this._cfgService.getAll();
  }
}
